<template>
  <v-snackbar v-model="showMessage" top>
    <p class="text-center">{{ message }}</p>
    <template v-slot:action="{ attrs }">
      <v-btn color="primary" text v-bind="attrs" @click="showMessage = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
    computed: {
    ...mapFields(["showMessage", "message"]),
  },
}
</script>

<style>
</style>